/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import HTML from 'html-parse-stringify2'
import { renderNodes } from './utils'

const LocalizationText = ({ children }) => {
  const ast = HTML.parse(`<0>${children}</0>`)
  return renderNodes(ast[0].children)
}

export default LocalizationText
